import http from "../../services/http";
import storage from "../../services/storage";
import { setToken, setUser } from "../auth/authReducer";
const path1 = "api/student";
const path = "api/auth/student";

const signupUser = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path1 + "/signUp", body });

      //<div>{res}</div>;
      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers["x-auth-token"];
      dispatch(setToken(xAuthToken));
      dispatch(setUser(user));

      setCookie("xAuthToken", xAuthToken, 365);
      storage.store("xAuthToken", xAuthToken);
      storage.store("user", user);
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const signinUser = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.post({ url: path + "/signin", body });
      const {
        data: { data: user },
        headers,
      } = res;
      const xAuthToken = headers["x-auth-token"];
      dispatch(setToken(xAuthToken));
      dispatch(setUser(user));
      setCookie("xAuthToken", xAuthToken, 365);
      storage.store("xAuthToken", xAuthToken);
      storage.store("user", user);
      // //onSuccess event firing
      if (onSuccess) onSuccess(res);
    } catch (err) {
      //onError event firing
      if (onError) onError(err);
      //else handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const forgotPassword = async ({ body }) => {
  try {
    const res = await http.post({ url: "api/auth/forgot_password", body });
    const { data = {} } = res;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const resetPasswordTokenVerify = async ({ body }) => {
  try {
    const res = await http.post({ url: "api/auth/verify_token", body });
    const { data = {} } = res;
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

const resetPassword = async ({ body }) => {
  try {
    const res = await http.put({ url: "api/auth/reset_password", body });
    const { data = {} } = res;
    return data;
  } catch (err) {
    throw new Error(err);
    // return Promise.reject(err);
  }
};

export {
  signupUser,
  signinUser,
  resetPassword,
  forgotPassword,
  resetPasswordTokenVerify,
};

const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  if (typeof window !== "undefined")
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
